import request from '../utils/request';
import { ContactUsPayload } from '../utils/types';

export const contactUs = async (payload: ContactUsPayload): Promise<any> => {
    await request.post(`/users/contact-us`, payload);
};
